export default "__VITE_ASSET__Fcyns2KF__"